import Sidebar from "../Sidebar";
import { Outlet } from "react-router-dom";

import React from "react";

interface LayoutProps {
  onLogout: () => void;
}

const Layout: React.FC<LayoutProps> = ({ onLogout }) => {
  return (
    <div className="container w-full max-w-full bg-darkcolor-800 pl-[55px] 2xl:pl-[68px]">
      <Sidebar onLogout={onLogout} />
      <Outlet />
    </div>
  );
};

export default Layout;
